import { Component } from "../base/Component";
import { ensureElement, handlePrice } from "../../utils/utils";
export class Success extends Component {
    constructor(container, actions) {
        super(container);
        this._close = ensureElement('.order-success__close', this.container);
        this._total = ensureElement('.order-success__description', this.container);
        if (actions === null || actions === void 0 ? void 0 : actions.onClick) {
            this._close.addEventListener('click', actions.onClick);
        }
    }
    set total(value) {
        this.setText(this._total, 'Списано ' + handlePrice(value) + ' синапсов');
    }
}
